import { AsyncPipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';
import { Store } from '@ngrx/store';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DxButtonModule } from 'devextreme-angular';
import { interval, Observable, Subscription, switchMap } from 'rxjs';
import { SsoLogoutService } from '../auth/sso-logout.service';
import { DialogHelperService } from '../shared/dialogs/services/dialog-helper.service';
import { getLanguageStatus } from '../shared/language/utils/language.utils';
import { LocalStorageService } from '../shared/local-storage.service';
import { LanguagesEnum } from '../shared/models/corr-language.enum';
import { Identifier } from '../shared/models/storage.models';
import { SharedPopupModule } from '../shared/popup/popup.module';
import { selectAuthenticatedUser } from '../store/user/user.selectors';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  imports: [TranslateModule, AsyncPipe, DxButtonModule, SharedPopupModule],
})
export class HeaderComponent implements OnInit, OnDestroy {
  isAuthenticated$: Observable<boolean> | undefined | null = null;
  languages = [
    { id: LanguagesEnum.EN_CA, name: 'English' },
    { id: LanguagesEnum.FR_CA, name: 'French' },
  ];
  currentLanguage?: string;
  languagesEnum = LanguagesEnum;
  newUpdateAvailable = false;
  showRefreshPopup = false;
  languageStatus = getLanguageStatus();
  subscription = new Subscription();
  constructor(
    private store: Store<any>,
    public translateService: TranslateService,
    private localStorageService: LocalStorageService,
    private router: Router,
    private swUpdate: SwUpdate,
    private ref: ChangeDetectorRef,
    private dialogHelperService: DialogHelperService,
    private ssoLogoutService: SsoLogoutService
  ) {
    if (this.swUpdate.isEnabled) {
      this.subscription.add(
        this.swUpdate.versionUpdates.subscribe((event) => {
          if (event.type === 'VERSION_READY') {
            this.promptUser();
          }
        })
      );

      this.subscription.add(
        interval(1800000)
          .pipe(
            switchMap(() => {
              return this.swUpdate.checkForUpdate();
            })
          )
          .subscribe((isUpdateAvailable) => {
            if (isUpdateAvailable) {
              // Notify user or automatically refresh
              this.promptUser();
            }
          })
      );
    }
  }
  promptUser() {
    this.newUpdateAvailable = true;
    this.showRefreshPopup = true;
    this.ref.markForCheck();
  }
  updateToLatest(): void {
    this.swUpdate.activateUpdate().then(() => document.location.reload());
  }
  ngOnInit() {
    this.isAuthenticated$ = this.store.select(selectAuthenticatedUser);

    this.currentLanguage =
      this.localStorageService.getStorageItem(Identifier.TYPE_LANGUAGE).value ?? this.translateService.getDefaultLang();
  }
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
  onLogout() {
    this.subscription.add(
      this.dialogHelperService
        .confirmDialog(this.translateService.instant('confirm_messages.logout'))
        .pipe(
          switchMap((dialogResult) => {
            if (dialogResult) {
              this.ssoLogoutService.logout();
            }
            return [];
          })
        )
        .subscribe()
    );
  }

  onLanguageChange(lng: string) {
    this.localStorageService.setStorageItem(Identifier.TYPE_LANGUAGE, lng);
    this.currentLanguage = lng;
  }
  onGoTo(path: string) {
    this.router.navigate([path]);
  }

  onBackClicked() {
    this.router.navigate(['/home']);
  }
}
